module.exports = __webpack_public_path__ + "static/img/icon_Lucky_draw@2x.c2b4dc89.png";